/* AppTilesGridContainer.ts generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["mobileColumns", "tabletColumns", "desktopColumns"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _10 = "@media (min-width:64rem){._1rqt8llh{grid-template-columns:var(--_bnc5jk)}._pdlmhiv4{gap:var(--ds-space-400)}}";
const _9 = "@media (min-width:48rem) and (max-width:63.99rem){._1da7pg39{grid-template-columns:var(--_861wfr)}._1gzvl6l0{gap:var(--ds-space-300)}}";
const _8 = "._1p57xjmg{row-gap:var(--ds-space-200)}";
const _7 = "._yv0e1gma{grid-template-columns:var(--_18ukq9a)}";
const _6 = "._qtt8glyw{list-style:none}";
const _5 = "._19bvidpf{padding-left:0}";
const _4 = "._n3tdidpf{padding-bottom:0}";
const _3 = "._u5f3idpf{padding-right:0}";
const _2 = "._ca0qidpf{padding-top:0}";
const _ = "._1e0c11p5{display:grid}";
export const AppTilesGridContainer = forwardRef((_ref, __cmplr) => {
  var _cmplp$mobileColumns, _cmplp$tabletColumns, _cmplp$desktopColumn, _cmplp$desktopColumn2;
  let {
      as: C = "ul",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  const {
      mobileColumns,
      tabletColumns,
      desktopColumns
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_18ukq9a": ix("repeat(".concat((_cmplp$mobileColumns = __cmplp.mobileColumns) !== null && _cmplp$mobileColumns !== void 0 ? _cmplp$mobileColumns : 1, ", minmax(0, 1fr))")),
        "--_861wfr": ix("repeat(".concat((_cmplp$tabletColumns = __cmplp.tabletColumns) !== null && _cmplp$tabletColumns !== void 0 ? _cmplp$tabletColumns : 2, ", minmax(0, 1fr))")),
        "--_bnc5jk": ix("repeat(auto-fill, minmax(max(272px, calc((100% - ".concat((((_cmplp$desktopColumn = __cmplp.desktopColumns) !== null && _cmplp$desktopColumn !== void 0 ? _cmplp$desktopColumn : 3) - 1) * 32, "px)/").concat((_cmplp$desktopColumn2 = __cmplp.desktopColumns) !== null && _cmplp$desktopColumn2 !== void 0 ? _cmplp$desktopColumn2 : 3, ")), 1fr))"))
      }),
      ref: __cmplr,
      className: ax(["_1e0c11p5 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _yv0e1gma _1p57xjmg _1da7pg39 _1gzvl6l0 _1rqt8llh _pdlmhiv4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppTilesGridContainer.displayName = 'AppTilesGridContainer';
}